module.exports = __webpack_public_path__ + "static/media/collision_box.vertex.8e132e16.glsl";